import React from 'react';
import Field from './Field';
import Grid from '@mui/material/Grid2';
import Slider from '@mui/material/Slider';


export default function SliderField(props) {
  const { question, tooltip, answer, updateAnswer, min, max, step, primarycolor, marks } = props;

  const handleSliderChange = (event, newValue) => {
    updateAnswer(newValue);
  };

  // Convert marks object to array if necessary
  const marksArray = Array.isArray(marks)
    ? marks
    : Object.keys(marks).map((key) => ({ value: Number(key), label: marks[key] }));

  return (
    <Field question={question} tooltip={tooltip}>
      <Grid size={12} className="bq-options-slider">
        <Slider
          value={typeof answer === 'number' ? answer : min}
          onChange={handleSliderChange}
          aria-labelledby="slider"
          valueLabelDisplay="auto"
          min={min}
          max={max}
          step={step}
          marks={marksArray}
          sx={
            primarycolor
              ? {
                  color: primarycolor,
                  '& .MuiSlider-track': { border: 'none', height: 10 },
                  '& .MuiSlider-rail': { opacity: 0.5, backgroundColor: '#bfbfbf', height: 10 },
                  '& .MuiSlider-thumb': { height: 24, width: 24 }
                }
              : {
                  '& .MuiSlider-track': { border: 'none', height: 10 },
                  '& .MuiSlider-rail': { opacity: 0.5, backgroundColor: '#bfbfbf', height: 10 }
                }
          }
        />
      </Grid>
    </Field>
  );
}